module.exports = __webpack_public_path__ + "static/media/PanasonicLogo.91d6864f.png";